import { render, staticRenderFns } from "./Intercom.vue?vue&type=template&id=5f605c8d&scoped=true&"
import script from "./Intercom.vue?vue&type=script&lang=js&"
export * from "./Intercom.vue?vue&type=script&lang=js&"
import style0 from "./Intercom.vue?vue&type=style&index=0&id=5f605c8d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f605c8d",
  null
  
)

export default component.exports